const Whatsapp = () => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icon hoverable"
      aria-label="Shakeel Haider's Whatsapp contact"
    >
      <g clipPath="url(#clip0_141_145)">
        <path
          d="M170 0H30C13.4315 0 0 13.4315 0 30V170C0 186.569 13.4315 200 30 200H170C186.569 200 200 186.569 200 170V30C200 13.4315 186.569 0 170 0Z"
          fill="#25D366"
        />
        <path
          d="M48.0472 153.516L53.5159 128.125C46.487 117.039 43.745 103.768 45.8044 90.8039C47.8637 77.8394 54.583 66.0719 64.7014 57.7092C74.8198 49.3465 87.642 44.9633 100.762 45.3819C113.883 45.8006 126.399 50.9924 135.964 59.9832C145.529 68.974 151.484 81.1459 152.713 94.2153C153.941 107.285 150.359 120.353 142.637 130.969C134.916 141.585 123.586 149.019 110.774 151.875C97.9614 154.732 84.5469 152.815 73.0472 146.485L48.0472 153.516Z"
          fill="#25D366"
          stroke="white"
          strokeWidth="13"
        />
        <path
          d="M120.312 106.641C119.14 105.859 117.968 105.469 116.797 107.031L112.109 113.281C110.937 114.063 110.156 114.453 108.593 113.672C102.734 110.547 94.531 107.031 87.4997 95.3125C87.1091 93.75 87.8903 92.9688 88.6716 92.1875L92.1872 86.7188C92.9685 85.9375 92.5778 85.1563 92.1872 84.375L87.4997 73.0469C86.3278 69.9219 85.156 70.3125 83.9841 70.3125H80.8591C80.0778 70.3125 78.5153 70.7031 76.9528 72.2656C68.3591 80.8594 71.8747 92.9688 78.1247 100.781C79.2966 102.344 87.1091 116.406 103.906 123.828C116.406 129.297 119.14 128.516 122.656 127.734C126.953 127.344 131.25 123.828 133.203 120.312C133.593 119.141 135.547 114.063 133.984 113.281"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_145">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Whatsapp;
